import React from 'react';
import { Box, Typography } from '@mui/material';
import MarkdownRenderer from '@components/MarkdownRenderer';
import variationsFAQObj from '../../faq';

const VariationsFAQ = () => {
  return (
    <Box>
      {variationsFAQObj.map((faq) => (
        <Box key={faq.heading}>
          <Typography variant="h5" component="h2" gutterBottom>
            {faq.heading}
          </Typography>
          <Box mb={2} mt={2}>
            <Typography variant="body1" gutterBottom component="div">
              <MarkdownRenderer content={faq.content} />
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default VariationsFAQ;
